import * as React from 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { cn } from '@companion-professional/webutils';
import { ChevronRight } from 'lucide-react';

// DropdownMenuSubTrigger is the trigger for opening a sub-menu that's in a sibling <DropdownMenuSubContent/> component.
// This component should be inside a <DropdownMenuSub/> component.  It is a clickable item that has a chevron on the
// right side to indicate that it will open a sub-menu.
export const DropdownMenuSubTrigger = React.forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.SubTrigger>,
  React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.SubTrigger> & {
    inset?: boolean;
  }
>(({ className, inset, children, ...props }, ref) => (
  <DropdownMenuPrimitive.SubTrigger
    ref={ref}
    className={cn(
      'flex',
      'cursor-default',
      'select-none',
      'focus:cursor-pointer',
      'focus:text-on-accent',
      'focus:bg-accent',
      'items-center',
      'rounded-md',
      'px-2',
      'py-1.5',
      'text-md',
      'outline-none',
      'data-[state=open]:bg-accent',
      inset && 'pl-8',
      className
    )}
    {...props}
  >
    {children}
    <ChevronRight className="ml-auto h-4 w-4" />
  </DropdownMenuPrimitive.SubTrigger>
));
DropdownMenuSubTrigger.displayName = DropdownMenuPrimitive.SubTrigger.displayName;
